<template>
  <b-card style="max-width: 900px; min-width: 300px; margin: auto;">
    <b-card-text class="mb-5">
      <div class="d-flex flex-column align-items-center">
        <transition name="slide-fade-up">
          <router-link to="/login">
            <b-img
              :src="require('@/assets/images/logo_centered.svg')"
              width="300"
              class="rounded-0 mb-5"
          /></router-link>
        </transition>

        <h1>Terms and Conditions</h1>
        <b-row>
          <b-col>
            <ol>
              <li
                class="numeric bold"
                v-for="(terms, index) in termsAndConditions"
                :key="index"
              >
                <span>{{ terms.title }}</span>
                <p v-if="terms.description">
                  {{ terms.description }}
                </p>
                <ol>
                  <li
                    class="numeric"
                    v-for="(detail, index) in terms.details"
                    :key="index"
                  >
                    <p v-html="detail.description"></p>
                    <ol>
                      <li
                        :class="detail.roman ? 'roman' : 'alphabet'"
                        v-for="(innerDetail, index) in detail.details"
                        :key="index"
                        v-html="innerDetail"
                      ></li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>
          </b-col>
        </b-row>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import termsAndConditions from '@/utils/termsAndConditions'
export default {
  computed: {
    termsAndConditions() {
      return termsAndConditions
    }
  }
}
</script>
<style lang="scss" scoped>
ol {
  list-style-type: none;
  counter-reset: item;
  margin: 0;
  padding: 0;
}

ol > li.numeric {
  display: table;
  counter-increment: item;
  margin-bottom: 0.6em;
}

ol > li.numeric:before {
  content: counters(item, '.') '. ';
  display: table-cell;
  padding-right: 0.6em;
}

li ol > li.numeric {
  margin: 0;
}

li ol > li.numeric:before {
  content: counters(item, '.') ' ';
}
ol > li.numeric.bold {
  &:before {
    content: counters(item, '.') '. ';
    display: table-cell;
    padding-right: 0.6em;
    font-weight: bold;
  }

  span {
    font-size: 18px;
    font-weight: bold;
    padding: 16px 0;
    display: block;
  }
}
p {
  text-align: justify;
}

ol > li.alphabet {
  display: table;
  counter-increment: item;
  margin-bottom: 0.6em;
  padding-bottom: 0.6em;
}

ol > li.alphabet:before {
  content: counter(item, lower-alpha) '. ';
  display: table-cell;
  padding-right: 0.6em;
}

li ol > li.alphabet {
  margin: 0;
}

li ol > li.alphabet:before {
  content: '(' counter(item, lower-alpha) ') ';
}

ol > li.roman {
  display: table;
  counter-increment: item;
  margin-bottom: 0.6em;
  padding-bottom: 0.6em;
}

ol > li.roman:before {
  content: counter(item, lower-alpha) '. ';
  display: table-cell;
  padding-right: 0.6em;
}

li ol > li.roman {
  margin: 0;
}

li ol > li.roman:before {
  content: '(' counter(item, lower-roman) ') ';
}

.card {
  box-shadow: none;
}
</style>
